import { v4 as uuidv4 } from "uuid";

export interface IQualification {
	type?: string;
	typeError?: string;
	place?: string;
	qualificationName?: string;
	date?: string;
	qualificationId?: string;
	orderIndex: number;
	excludeFromVetting?: boolean;
	createdAt?: string;
	qualificationExpiry?: string;
}
export class QualificationModel {
	type?: string;
	typeError?: string;
	place?: string;
	qualificationName?: string;
	date?: string;
	qualificationId?: string;
	orderIndex: number;
	excludeFromVetting?: boolean;
	createdAt?: string;
	qualificationExpiry?: string;

	constructor(data: Partial<QualificationModel> = {}) {
		this.type = data.type || "";
		this.place = data.place || "";
		this.qualificationName = data.qualificationName || "";
		this.date = data.date || "";
		this.qualificationId = data.qualificationId || uuidv4();
		this.orderIndex = data.orderIndex || 0;
		this.excludeFromVetting = data.excludeFromVetting !== null && data.excludeFromVetting !== undefined ? data.excludeFromVetting : false;
		this.createdAt = data.createdAt || "";
		this.qualificationExpiry = data.qualificationExpiry || "";
	}
}
